import { cva } from "./index";

export const table = cva({
  base: "grid divide-y divide-obsidian-200 rounded-md border border-obsidian-200 bg-white overflow-y-auto",
});

export const tableHeader = cva({
  base: "col-span-full grid grid-cols-subgrid gap-6 px-4 py-2 text-xs font-medium text-obsidian-700",
});

export const tableRow = cva({
  base: "col-span-full grid grid-cols-subgrid items-center gap-6 px-4 py-3",
  variants: {
    interactive: {
      true: "cursor-pointer transition hover:bg-obsidian-50",
      false: "",
    },
    selected: {
      true: "bg-blue-50",
      false: "",
    },
  },
  defaultVariants: {
    interactive: false,
    selected: false,
  },
});

export const tableFooter = cva({
  base: "col-span-full grid grid-cols-subgrid gap-6 px-4 py-3",
  variants: {
    muted: {
      true: "bg-obsidian-50 font-semibold",
      false: "",
    },
  },
  defaultVariants: {
    muted: false,
  },
});

export const tableCell = cva({
  base: "",
  variants: {
    numeric: {
      true: "tabular-nums text-right",
      false: "",
    },
  },
  defaultVariants: {
    numeric: false,
  },
});
